import { storageAPI } from '@cutwise/utils';

import AppErrorMessage from '@/dmdrive/core/components/AppErrorMessage/AppErrorMessage';
import { PAGE_MAIN } from '@/dmdrive/core/constants/pages';
import { KEY_TOKEN, KEY_URI_AFTER_AUTH } from '@/dmdrive/core/constants/storage';
import { AppError } from '@/dmdrive/core/entities/AppError';

function Auth() {
  const hash = new URLSearchParams(window.location.hash.substring(1))?.get('access_token');

  if (hash) {
    storageAPI.set(KEY_TOKEN, hash);

    const redirectURI = storageAPI.get(KEY_URI_AFTER_AUTH);

    storageAPI.remove(KEY_URI_AFTER_AUTH);

    window.location.href = redirectURI || PAGE_MAIN;

    return null;
  }

  return <AppErrorMessage error={new AppError()} />;
}

export default Auth;
